import {isEmpty, isNil} from 'ramda';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

const BADGE_LABEL_MAX_LENGTH = 3;
const MIN_WORDS_FOR_INITIALS = 2;

/** Letters only, so an en-dash between city and district is not counted as a word. */
const LETTER_WORD_PATTERN = /\p{L}+/gu;

/**
 * The badge label. The tenant-configured code wins; otherwise initials keep sibling
 * branches apart — 'Praha – Hostivař' and 'Praha – Letňany' become PH and PL, where the
 * first three letters would make both PRA — and a single-word name takes three letters so
 * the badge keeps the visual weight of a real code.
 *
 * Platform's `getInitials` is unusable here: it splits on spaces, so it renders
 * 'Praha – Hostivař' as 'P–'.
 */
export function getBranchBadgeLabel(branchCode: string | Nullish, branchName: string) {
  if (!isNil(branchCode) && !isEmpty(branchCode)) {
    return branchCode.toUpperCase();
  }

  const words = branchName.match(LETTER_WORD_PATTERN) ?? [];

  if (words.length >= MIN_WORDS_FOR_INITIALS) {
    return words
      .slice(0, BADGE_LABEL_MAX_LENGTH)
      .map((word) => word.charAt(0))
      .join('')
      .toUpperCase();
  }

  const singleWord = words.at(0);

  if (isNil(singleWord)) {
    return EMPTY_PLACEHOLDER;
  }

  return singleWord.slice(0, BADGE_LABEL_MAX_LENGTH).toUpperCase();
}
